/**
 * The scheduler's free slots — the one answer to "how much of today is open".
 *
 * `GET /api/ai-scheduler/free-slots?days_ahead=1` honours the person's own
 * wake, sleep, work hours and work days (their profile's day anchors) and
 * subtracts every calendar event and Horton block, starting today at their
 * current quarter-hour. Returns null on any failure so a caller can fall
 * back rather than show a number nobody computed.
 */
import type { FreeSlotLike } from '../utils/freeTime'

export interface FreeSlotsAnswer {
  free_slots: FreeSlotLike[]
  total_free_minutes: number
}

export async function fetchFreeSlots(daysAhead = 1): Promise<FreeSlotsAnswer | null> {
  try {
    const res = await fetch(`/api/ai-scheduler/free-slots?days_ahead=${Math.max(1, Math.min(7, daysAhead))}`, {
      credentials: 'include',
    })
    if (!res.ok) return null
    const body = await res.json()
    if (!body?.success || !Array.isArray(body.free_slots)) return null
    return {
      free_slots: body.free_slots as FreeSlotLike[],
      total_free_minutes: Number(body.total_free_minutes) || 0,
    }
  } catch {
    return null
  }
}
